import React from 'react';
import './header_view.css';
import WhatsAppButton from '../../../core/components/buttons/whatsapp_button/whatsapp_button.jsx';
import { HiBars3 } from 'react-icons/hi2';
import { useHeaderViewModel } from '../view_model/header_view_model.jsx';
import { headerMapper } from '../utils/mapper/header_mapper.jsx';

const HeaderView = () => {
    const { navLinks } = headerMapper;
    const {
        isMenuOpen,
        isHeaderVisible,
        handleScrollToSection,
        toggleMenu,
        closeMenu,
        handleLogoClick,
    } = useHeaderViewModel();

    return (
        <>
            {isMenuOpen && (
                <div
                    className="menu-overlay"
                    onClick={closeMenu}
                ></div>
            )}
            <header className={`header ${isMenuOpen ? 'menu-open' : ''} ${!isHeaderVisible ? 'header--hidden' : ''}`}>
                <div className="container row">
                    <div
                        className='logo col-1'
                        onClick={handleLogoClick}
                        style={{ cursor: 'pointer' }}
                    ></div>
                    <div className={`col-10 nav ${isMenuOpen ? 'nav-open' : ''}`}>
                        <div className="nav-logo">
                            <div className="nav-logo-image"></div>
                        </div>
                        {navLinks.map((link) => (
                            <a
                                key={link.id}
                                href={link.href}
                                className="text-white nav-link"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleScrollToSection(link.id);
                                }}
                            >
                                {link.label}
                            </a>
                        ))}
                        {isMenuOpen && (
                            <div className="nav-whatsapp">
                                <WhatsAppButton />
                            </div>
                        )}
                    </div>
                    <div className='button_whats col-1'>
                        {!isMenuOpen && <WhatsAppButton />}
                        <button 
                            className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} 
                            onClick={toggleMenu}
                        >
                            {isMenuOpen ? <span></span> : <HiBars3 />}
                        </button>
                    </div>
                </div>
            </header>
        </>
    );
};

export default HeaderView;
